import * as Yup from "yup";

// Esquema de validación para cada invitado dentro del GuestModal.
export const buildGuestSchema = (t) =>
  Yup.object().shape({
    type: Yup.string()
      .oneOf(
        ["Adulto", "Niño"],
        t("validation.oneOf", { values: `${t("adult")}, ${t("child")}` })
      )
      .required(t("validation.required")),
    name: Yup.string()
      .min(2, t("validation.minChars", { min: 2 }))
      .required(t("validation.required")),
    dni: Yup.string().required(t("validation.required")),
    relationship: Yup.string().required(t("validation.required")),
  });
